document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("promo-popup");
  const closeBtn = document.querySelector(".popup-close");
  const popupSubmitBtn = popup.querySelector("a");
  const appearDelay = parseInt(popup.dataset.appearDelay);

  const copyCodeBtn = popup.querySelector("#copy-promo-code");
  const promoCodeInput = popup.querySelector('#promo-code');

  function readCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function isNewSession() {
    return !sessionStorage.getItem("sessionClosed");
  }

  const isAnAdult = readCookie("isAnAdultChecked");
  const popupClosed = localStorage.getItem("popupClosed"); 
  const sessionClosed = sessionStorage.getItem("sessionClosed"); 

  
  if (isAnAdult && (!popupClosed || isNewSession())) {
    setTimeout(function () {
      popup.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
    }, appearDelay);
  }

  closeBtn.addEventListener("click", function () {
    popup.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
    localStorage.setItem("popupClosed", "true"); 
    sessionStorage.setItem("sessionClosed", "true"); 
  });

  popupSubmitBtn.addEventListener("click", function (event) {
    event.preventDefault();
    localStorage.setItem("popupClosed", "true"); 
    sessionStorage.setItem("sessionClosed", "true"); 

    const redirectUrl = "https://www.smokeandvape.ca/";
    window.location.href = redirectUrl;
  });

  copyCodeBtn.addEventListener('click', function() {
    promoCodeInput.select();
    promoCodeInput.setSelectionRange(0, 99999); 

    const copyIcon = popup.querySelector('.bi-clipboard');
    const checkIcon = popup.querySelector('.bi-clipboard-check');
   
    navigator.clipboard.writeText(promoCodeInput.value);

    copyIcon.style.display = "none";  
    checkIcon.style.display = "inline";  
    
    setTimeout(function() {
      copyIcon.style.display = "inline";
      checkIcon.style.display = "none";
    }, 2000);
  });
});
